import { memo } from 'react'
import classNames from 'classnames'
import injectSheet from 'react-jss'
import DelayLink from '@/components/DelayLink'
import style from './style'

const BtnLink = ({
  classes,
  className,
  color,
  label,
  link,
  onClick,
  // background,
  hover,
}) => {
  return link ? (
    <DelayLink
      to={link}
      onClick={onClick}
      className={classNames({
        [classes.root]: true,
        [classes.rootHover]: link || onClick,
        // [classes.rootDefault]: color === 'default',
        // [classes.rootBackground]: background,
        BtnLink__root: true,
        [className]: className,
      })}
    >
      {label && (
        <span
          className={classNames({
            [classes.text]: true,
            BtnLink__text: true,
          })}
        >
          {label}
        </span>
      )}
    </DelayLink>
  ) : (
    <button
      onClick={onClick}
      className={classNames({
        [classes.root]: true,
        [classes.rootHover]: hover,
        // [classes.rootDefautColor]: color === 'default',
        [classes.rootLightColor]: color === 'light',
        [classes.rootDarkColor]: color === 'dark',
        BtnLink__root: true,
        [className]: className,
      })}
      aria-label="go-to-link"
    >
      {label && (
        <span
          className={classNames({
            [classes.text]: true,
            BtnLink__text: true,
          })}
        >
          {label}
        </span>
      )}
      <div
        className={classNames({
          [classes.circle]: true,
          BtnLink__circle: true,
        })}
      >
        <div
          className={classNames({
            [classes.arrow]: true,
            BtnLink__arrow: true,
          })}
        />
      </div>
    </button>
  )
}

BtnLink.defaultProps = {
  color: 'default',
  background: false,
}

export default injectSheet(style)(memo(BtnLink))
